module.exports = __webpack_public_path__ + "img/悬框.3f0abe07.png";